import { useCallback } from "react";
import { useNavigate as useRRNavigate } from "react-router";

export const useNavigate = () => {
  const navigate = useRRNavigate();
  return useCallback(
    (path: string | -1) =>
      path === -1
        ? navigate(-1)
        : navigate(`${path}${window.location.search ?? ""}`),
    [navigate]
  );
};

export const getQuery = (key: string) =>
  window.location.search?.split(`${key}=`)[1]?.split("&")?.[0] ?? undefined;

export const FocusIdFunc = (id: string) => document.getElementById(id)?.focus();
